import React from "react";

const SubModuleTag = ({
  module,
  child,
  sub,
  selectedChildModule,
  toggleSubModule,
  type = "core",
}) => {
  console.log("sub: ", sub);
  const subSelected = selectedChildModule?.SUBSCRIBED_SUBMODULE_DETAILS?.some(
    (item) => item.SUBMODULE_ID === sub.SUBMODULE_ID,
  );

  const theme =
    type === "addon"
      ? {
          selected: `
              bg-violet-50 dark:bg-violet-500/10
              border-violet-300 dark:border-violet-500/40
              text-violet-700 dark:text-violet-300
            `,

          checkbox: `
              bg-violet-600 border-violet-600
            `,
        }
      : {
          selected: `
              bg-teal-50 dark:bg-teal-500/10
              border-teal-300 dark:border-teal-500/40
              text-teal-700 dark:text-teal-300
            `,

          checkbox: `
              bg-teal-600 border-teal-600
            `,
        };

  return (
    <button
      type="button"
      onClick={() =>
        toggleSubModule(module.BASEMODULE_ID, child.MODULE_ID, sub)
      }
      className={`
        flex items-center gap-3
        px-3.5 py-2.5
        rounded-xl border
        transition-all duration-300

        ${
          subSelected
            ? theme.selected
            : `
              bg-white dark:bg-slate-900
              border-slate-200 dark:border-slate-700
            `
        }
      `}
    >
      {/* CHECKBOX */}

      <span
        className={`
          w-4 h-4 rounded-md border
          flex items-center justify-center

          ${
            subSelected
              ? theme.checkbox
              : `
                border-slate-300
                dark:border-slate-600
              `
          }
        `}
      >
        {subSelected && (
          <svg className="w-2.5 h-2.5 text-white" fill="none" viewBox="0 0 8 8">
            <path d="M1 4l2 2 4-4" stroke="currentColor" strokeWidth="1.5" />
          </svg>
        )}
      </span>

      {/* CONTENT */}

      <div className="flex flex-col">
        <span className="text-sm font-medium">{sub.SUBMODULE_NAME}</span>

        {/* THIS PRICE COUNTS */}

        <span className="text-[11px] font-semibold mt-1">
          +$
          {sub.SUBMODULE_BASEPRICE}
          /month
        </span>
      </div>
    </button>
  );
};

export default SubModuleTag;
